import { IConfig } from './IConfig';
import { aemConfig } from './aemConfig';

const prodConfig: IConfig = {
  apiUrl: `${aemConfig.backendDomain}/api/kontakt`
};

export default prodConfig;
